import { facadeApi } from 'api'
import { gDriveAuthPayload } from 'types/storageAccount'

export const authGDriveAccountAccountApi = ({ authCode, redirectUri }: gDriveAuthPayload) =>
  facadeApi.post<null>('/file-manager/v1/auth', null, {
    params: {
      authCode,
      redirectUri,
    },
  })
